import {Axios} from "axios";
import {z} from "zod";
import {Ticket, Event, EventQuestion} from "../../models/Models";

export const getEventRequestSchema = z.object({
  data: z.object({
    eventId: z.number(),
  }),
});
export type GetEventRequestPayload = z.infer<typeof getEventRequestSchema>;

export type EventApiResponse = {
  data: {
    event: Event;
    tickets: Ticket[];
    eventQuestions: EventQuestion[];
  };
  message: string;
};

export type EventDataApiResponse = {
  event: Event;
  tickets: Ticket[];
  eventQuestions: EventQuestion[];
};

export async function getEventData(
  requestPayload: GetEventRequestPayload,
  axiosInstance: Axios
): Promise<EventDataApiResponse> {
  getEventRequestSchema.parse(requestPayload);
  const response = await axiosInstance.get(
    `/event/${requestPayload.data.eventId}`
  );
  return response.data.data;
}
